// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDollarSign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M18.137 6.446c0 1.165-1.337 2.023-1.406 1.92-.994-1.166-2.709-2.023-4.423-2.023-1.748 0-2.846.788-2.846 1.954 0 1.372 1.44 1.749 3.463 2.194 2.435.515 5.589 1.509 5.589 4.938 0 2.64-1.851 4.491-4.903 4.971v1.029c0 1.2-.48 1.782-1.509 1.782h-.137c-1.097 0-1.508-.548-1.508-1.782v-.96c-3.189-.343-4.972-1.783-4.972-3.258 0-1.131 1.269-1.954 1.372-1.851.994 1.2 2.948 2.194 4.971 2.194 1.852 0 2.949-.788 2.949-1.954 0-1.44-1.612-1.851-3.532-2.297-2.297-.514-5.348-1.406-5.348-4.869 0-2.503 1.783-4.32 4.628-4.868v-.96c0-1.2.446-1.783 1.509-1.783h.171c1.063 0 1.509.548 1.509 1.783v.891c2.846.309 4.423 1.612 4.423 2.949z"
    />
  </svg>
);
export default SvgDollarSign;
